// TODO: replace whole file when API is available
// Seed data for the EXR monitoring list mock until the EXR backend exists. (GMTEC-20708)
import { SpecialPaymentProposalState } from '@coin/shared/core/util-enums';
import {
  ExceptionalRecognitionCompensationType,
  ExceptionalRecognitionPaymentCategory
} from '@coin/shared/exceptional-recognitions/util';
import { ExceptionalRecognitionRecord } from '../models/exceptional-recognition-record.model';

const { SignOnBonus, ExceptionalRecognition, TransformationIncentive } = ExceptionalRecognitionPaymentCategory;
const { Cash, StockAwards } = ExceptionalRecognitionCompensationType;
const { Approved, AutoApproved, Rejected, Pending } = SpecialPaymentProposalState;

// A representative spread across all three categories, both compensation types, every state and the
// Transformation-Incentive-only Board/CFO approval flags.
export const EXR_RECORD_MOCK_DATA: ExceptionalRecognitionRecord[] = [
  {
    id: 'exr-mock-record-1',
    assignmentId: 'A-100001',
    gid: 'Z001AAAA',
    firstname: 'Mara',
    lastname: 'Voss',
    placeOfAction: 'Germany',
    are: 'DE01',
    orgCode: 'DE-ENG-01',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: StockAwards,
    proposalDate: '2026-01-14',
    state: Approved,
    currency: 'EUR',
    amount: 45000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-2',
    assignmentId: 'A-100002',
    gid: 'Z002BBBB',
    firstname: 'Tobias',
    lastname: 'Kern',
    placeOfAction: 'Germany',
    are: 'DE01',
    orgCode: 'DE-SALES-04',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: Cash,
    proposalDate: '2026-02-03',
    state: Pending,
    currency: 'EUR',
    amount: 8000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open',
    comments: [
      {
        id: 'exr-mock-comment-1',
        text: 'Please double-check the amount against the plan budget.',
        author: { firstname: 'Hiroshi', lastname: 'Ito', gid: 'Z009HB01' },
        createdAt: '2026-02-05T09:12:00Z'
      }
    ]
  },
  {
    id: 'exr-mock-record-3',
    assignmentId: 'A-100003',
    gid: 'Z003CCCC',
    firstname: 'Priya',
    lastname: 'Nair',
    placeOfAction: 'India',
    are: 'IN07',
    orgCode: 'IN-RND-02',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: StockAwards,
    proposalDate: '2026-02-10',
    state: AutoApproved,
    currency: 'INR',
    amount: 12000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-4',
    assignmentId: 'A-100004',
    gid: 'Z004DDDD',
    firstname: 'Lucas',
    lastname: 'Ferreira',
    placeOfAction: 'Brazil',
    are: 'BR03',
    orgCode: 'BR-OPS-11',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-01-28',
    state: Pending,
    currency: 'BRL',
    amount: 250000,
    boardApproval: true,
    cfoApproval: false,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-5',
    assignmentId: 'A-100005',
    gid: 'Z005EEEE',
    firstname: 'Sofia',
    lastname: 'Marchetti',
    placeOfAction: 'Italy',
    are: 'IT02',
    orgCode: 'IT-ENG-06',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-03-01',
    state: Approved,
    currency: 'EUR',
    amount: 500000,
    boardApproval: true,
    cfoApproval: true,
    payrollExport: 'Done',
    comments: [
      {
        id: 'exr-mock-comment-2',
        text: 'Board approval confirmed in the March meeting.',
        author: { firstname: 'Dieter', lastname: 'Hoffmann', gid: 'Z009BD02' },
        createdAt: '2026-03-04T14:30:00Z'
      },
      {
        id: 'exr-mock-comment-3',
        text: 'CFO sign-off received.',
        author: { firstname: 'Akiko', lastname: 'Suzuki', gid: 'Z009CF03' },
        createdAt: '2026-03-06T08:05:00Z'
      }
    ]
  },
  {
    id: 'exr-mock-record-6',
    assignmentId: 'A-100006',
    gid: 'Z006FFFF',
    firstname: 'Daniel',
    lastname: 'Okoye',
    placeOfAction: 'United Kingdom',
    are: 'GB05',
    orgCode: 'GB-SALES-02',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: StockAwards,
    proposalDate: '2026-02-18',
    state: Rejected,
    currency: 'GBP',
    amount: 30000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-7',
    assignmentId: 'A-100007',
    gid: 'Z007GGGG',
    firstname: 'Emma',
    lastname: 'Larsen',
    placeOfAction: 'Denmark',
    are: 'DK01',
    orgCode: 'DK-RND-03',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: Cash,
    proposalDate: '2026-03-05',
    state: Approved,
    currency: 'DKK',
    amount: 6000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-8',
    assignmentId: 'A-100008',
    gid: 'Z008HHHH',
    firstname: 'Chen',
    lastname: 'Wei',
    placeOfAction: 'China',
    are: 'CN04',
    orgCode: 'CN-OPS-08',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-01-09',
    state: Pending,
    currency: 'CNY',
    amount: 90000,
    boardApproval: false,
    cfoApproval: false,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-9',
    assignmentId: 'A-100009',
    gid: 'Z009IIII',
    firstname: 'Olivia',
    lastname: 'Schmidt',
    placeOfAction: 'Germany',
    are: 'DE02',
    orgCode: 'DE-ENG-01',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: StockAwards,
    proposalDate: '2026-02-22',
    state: AutoApproved,
    currency: 'EUR',
    amount: 40000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-10',
    assignmentId: 'A-100010',
    gid: 'Z010JJJJ',
    firstname: 'Ahmed',
    lastname: 'Hassan',
    placeOfAction: 'United Arab Emirates',
    are: 'AE01',
    orgCode: 'AE-SALES-01',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: StockAwards,
    proposalDate: '2026-03-12',
    state: Pending,
    currency: 'AED',
    amount: 15000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-11',
    assignmentId: 'A-100011',
    gid: 'Z011KKKK',
    firstname: 'Julia',
    lastname: 'Novak',
    placeOfAction: 'Czechia',
    are: 'CZ01',
    orgCode: 'CZ-RND-01',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-02-14',
    state: Approved,
    currency: 'CZK',
    amount: 320000,
    boardApproval: true,
    cfoApproval: true,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-12',
    assignmentId: 'A-100012',
    gid: 'Z012LLLL',
    firstname: 'Marcus',
    lastname: 'Berg',
    placeOfAction: 'Sweden',
    are: 'SE02',
    orgCode: 'SE-ENG-05',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: Cash,
    proposalDate: '2026-01-31',
    state: Rejected,
    currency: 'SEK',
    amount: 5000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-13',
    assignmentId: 'A-100013',
    gid: 'Z013MMMM',
    firstname: 'Ana',
    lastname: 'García',
    placeOfAction: 'Spain',
    are: 'ES03',
    orgCode: 'ES-OPS-02',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: StockAwards,
    proposalDate: '2026-03-08',
    state: Approved,
    currency: 'EUR',
    amount: 35000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-14',
    assignmentId: 'A-100014',
    gid: 'Z014NNNN',
    firstname: 'Kenji',
    lastname: 'Sato',
    placeOfAction: 'Japan',
    are: 'JP01',
    orgCode: 'JP-RND-04',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-02-06',
    state: Pending,
    currency: 'JPY',
    amount: 180000,
    boardApproval: true,
    cfoApproval: false,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-15',
    assignmentId: 'A-100015',
    gid: 'Z015OOOO',
    firstname: 'Nora',
    lastname: 'Haugen',
    placeOfAction: 'Norway',
    are: 'NO01',
    orgCode: 'NO-SALES-03',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: StockAwards,
    proposalDate: '2026-03-15',
    state: AutoApproved,
    currency: 'NOK',
    amount: 9000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Done'
  },
  {
    id: 'exr-mock-record-16',
    assignmentId: 'A-100016',
    gid: 'Z016PPPP',
    firstname: 'Paulo',
    lastname: 'Costa',
    placeOfAction: 'Portugal',
    are: 'PT01',
    orgCode: 'PT-OPS-01',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-02-27',
    state: Pending,
    currency: 'EUR',
    amount: 220000,
    boardApproval: false,
    cfoApproval: true,
    payrollExport: 'Open'
  },
  // Approved but still missing the Board flag, so not fully approved and therefore deletable. (GMTEC-20711)
  {
    id: 'exr-mock-record-17',
    assignmentId: 'A-100017',
    gid: 'Z017QQQQ',
    firstname: 'Ingrid',
    lastname: 'Solberg',
    placeOfAction: 'Norway',
    are: 'NO02',
    orgCode: 'NO-ENG-02',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-03-18',
    state: Approved,
    currency: 'NOK',
    amount: 140000,
    boardApproval: false,
    cfoApproval: false,
    payrollExport: 'Open'
  },
  // Approved with the Board flag but without the CFO flag: fully approved (and thus protected) only while its amount
  // stays below the season's CFO approval threshold. (GMTEC-20711)
  {
    id: 'exr-mock-record-18',
    assignmentId: 'A-100018',
    gid: 'Z018RRRR',
    firstname: 'Victor',
    lastname: 'Almeida',
    placeOfAction: 'Portugal',
    are: 'PT02',
    orgCode: 'PT-RND-03',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-03-21',
    state: Approved,
    currency: 'EUR',
    amount: 50000,
    boardApproval: true,
    cfoApproval: false,
    payrollExport: 'Open'
  },
  // Fully approved, mapped and not yet exported: the straightforward final-export case. (GMTEC-20709)
  {
    id: 'exr-mock-record-19',
    assignmentId: 'A-100019',
    gid: 'Z019SSSS',
    firstname: 'Hannah',
    lastname: 'Weiss',
    placeOfAction: 'Germany',
    are: 'DE03',
    orgCode: 'DE-SALES-07',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: Cash,
    proposalDate: '2026-03-24',
    state: Approved,
    currency: 'EUR',
    amount: 42000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  {
    id: 'exr-mock-record-20',
    assignmentId: 'A-100020',
    gid: 'Z020TTTT',
    firstname: 'Diego',
    lastname: 'Rossi',
    placeOfAction: 'Italy',
    are: 'IT03',
    orgCode: 'IT-RND-02',
    assignedPlan: 'Exceptional Recognition 2026',
    category: ExceptionalRecognition,
    compensationType: StockAwards,
    proposalDate: '2026-03-25',
    state: AutoApproved,
    currency: 'EUR',
    amount: 11000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  // Transformation Incentive with both flags set and still Open: the only category that also needs Board/CFO. (GMTEC-20709)
  {
    id: 'exr-mock-record-21',
    assignmentId: 'A-100021',
    gid: 'Z021UUUU',
    firstname: 'Freya',
    lastname: 'Lindqvist',
    placeOfAction: 'Sweden',
    are: 'SE03',
    orgCode: 'SE-ENG-02',
    assignedPlan: 'Transformation Incentive 2026',
    category: TransformationIncentive,
    compensationType: StockAwards,
    proposalDate: '2026-03-26',
    state: Approved,
    currency: 'EUR',
    amount: 400000,
    boardApproval: true,
    cfoApproval: true,
    payrollExport: 'Open'
  },
  // Approved Sign-On Bonus without a mapped employee (no GID): excluded from a final export, included in a test export. (GMTEC-20709)
  {
    id: 'exr-mock-record-22',
    assignmentId: 'A-100022',
    gid: '',
    firstname: 'Noah',
    lastname: 'Meyer',
    placeOfAction: 'Germany',
    are: 'DE04',
    orgCode: 'DE-ENG-09',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: StockAwards,
    proposalDate: '2026-03-27',
    state: Approved,
    currency: 'EUR',
    amount: 38000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  },
  // The only pending Sign-On Bonus, and unmapped (no GID) on top: the one row whose approval chain can be regenerated
  // off a manually entered org code rather than off a mapped employee. (GMTEC-20707)
  {
    id: 'exr-mock-record-23',
    assignmentId: 'A-100023',
    gid: '',
    firstname: 'Elias',
    lastname: 'Brandt',
    placeOfAction: 'Germany',
    are: 'DE05',
    orgCode: 'DE-ENG-04',
    assignedPlan: 'Sign-On Bonus 2026',
    category: SignOnBonus,
    compensationType: Cash,
    proposalDate: '2026-03-30',
    state: Pending,
    currency: 'EUR',
    amount: 36000,
    boardApproval: null,
    cfoApproval: null,
    payrollExport: 'Open'
  }
];
